import "./Table.scss";
import "react-tabulator/lib/css/tabulator_bootstrap4.min.css";
import {ReactTabulator} from "react-tabulator";
import {useContext, useEffect, useState, useRef, forwardRef} from "react";
import axios from "axios";
import {toast} from "react-toastify";
import Loader from "../Loader/Loader";
import Modal, {ModalBody, ModalHeader} from "../Modal";
import Form from "../Form/Form";
import {useOutletContext, useNavigate, useHistory} from "react-router-dom";
import FormBill from "../Form/FormBill";
import {SetPrintDataContext} from "../../Pages";
import ReactToPrint, {PrintContextConsumer} from "react-to-print";
import BarcodeLabel from "../BarcodeLabel";
import FormKpiView from "../Form/FormKpiView";
import tableCalc from "../../utils/tableCalc";
import TabulatorTableOptions from "../../utils/TabulatorTableOptions";

export default function Table({
                                id,
                                hideColumns,
                                height,
                                name,
                                setTitleInDashboard,
                              }) {
  let outletContext = useOutletContext();
  id = id === undefined ? outletContext : id;
  name = name === undefined ? outletContext : name;
  console.log(name);
  const navigateTo = useNavigate();

  const [tableConfig, setTableConfig] = useState();
  const [selectedRow, setSelectedRow] = useState();
  const [showDataKpintIsOpen, setShowDataKpintIsOpen] = useState(false);
  const [modalOnclickDataPleaseKPI, setmodalOnclickDataPleaseKPI] = useState({
    title: "بدون عنوان",
    id: 0,
  });
  // const [data, setShowKpiDataModal] = useState(null);

  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();

  useEffect(() => {
    setTableConfig();

    id = id === undefined ? outletContext : id;

    axios({
      method: "GET",
      url: `${localStorage.getItem("apiUrl")}/list_json/`,
      params: {id: id},
      headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
    }).then(({data}) => {
      let columnsConfig = data.columns;

      tableCalc.addSeparator(columnsConfig, data.priceFields);

      setTitleInDashboard !== undefined && setTitleInDashboard(data.title);
      setTableConfig(data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, outletContext]);

  const [addDataModalIsOpen, setAddDataModalIsOpen] = useState(false);

  function addDataModalCallbackHandler({isOpen}) {
    setAddDataModalIsOpen(isOpen);
  }

  function submitSmsHandler() {
    let data = {
      type: "group",
      detail: {entityId: id, text: smsTextRef.current.value},
    };
    axios({
      method: "post",
      url: `${localStorage.getItem("apiUrl")}/sendSMS/`,
      data: data,
      headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
    }).then((response) => {
      console.log(response.data);
      setSmsModalIsOpen(false);
    });
  }

  // اینجا مدال صورتحساب رو دارم مثل بقیه آماده میکنم که کلیک کرد باز بشه
  const [invoiceModalIsOpen, setinvoiceModalIsOpen] = useState(false);

  function invoiceModalIsOpenCallbackHandler({isOpen}) {
    setinvoiceModalIsOpen(isOpen);
  }

  // آخر مودال صورت حساب
  const [editRecordrModalIsOpen, setEditRecordModalIsOpen] = useState(false);
  const [newKpintIsOpen, setNewKpintIsOpen] = useState(false);

  function newKpintIsOpenCallbackHandler({isOpen}) {
    setNewKpintIsOpen(isOpen);
  }

  function editRecordModalCallbackHandler({isOpen}) {
    setEditRecordModalIsOpen(isOpen);
  }

  function smsModalCallbackHandler({isOpen}) {
    setSmsModalIsOpen(isOpen);
  }

  const myReactTabulatorRef = useRef(null);
  const smsTextRef = useRef(null);

  const firstUpdate = useRef(true);
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
    } else {
      if (addDataModalIsOpen === false && editRecordrModalIsOpen === false) {
        const updateTableDataRequest = axios({
          method: "GET",
          url: `${localStorage.getItem("apiUrl")}/list_json/`,
          params: {id: id},
          headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
        }).then(({data}) => {
          // let columnsConfig = data.columns;

          // if (hideColumns) {
          //     for (const column of hideColumns) {
          //         columnsConfig.filter(
          //             ({field}) => field === column
          //         )[0].visible = false;
          //     }
          // }

          setTableConfig(data);
        });

        toast.promise(updateTableDataRequest, {
          pending: "در حال بروزرسانی جدول",
          success: "جدول با موفقیت بروزرسانی شد",
          error: "بروزرسانی جدول با مشکل مواجه شد",
        });
      }
    }
  }, [
    addDataModalIsOpen,
    editRecordrModalIsOpen,
    showDataKpintIsOpen,
    newKpintIsOpen,
  ]);
  const [smsModalIsOpen, setSmsModalIsOpen] = useState(false);

  function rowClickHandler(e, row) {
    // console.log(selectedRow.getData()["primaryKey"]);
    row.getTable().getSelectedRows().length === 0
      ? setSelectedRow()
      : setSelectedRow(row);
    console.log("Row Clicked!!!");
  }

  function removeRowHandler() {
    let toastContext = (
      <span>
        اگر مطمئن نیستید
        <button
          className="remove-cancel-btn"
          onClick={() => {
            source.cancel("Operation canceled by the user.");
          }}
        >
          لغو
        </button>
        کنید
      </span>
    );

    selectedRow !== undefined &&
    toast.warn(toastContext, {
      autoClose: 3000,
      onClose: () => removeRow(selectedRow),
    });
  }

  const setprint = useContext(SetPrintDataContext);

  let navigate = useNavigate();

  function printTableHandler() {
    if (tableConfig) {
      if (tableConfig.data.length === 0) {
        toast.error("چیزی برای پرینت وجود ندارد.");
      } else {
        // debugger
        myReactTabulatorRef.current.table.print(false, false);
      }
    }
  }

  function printFactorHandler(SelectedRow) {
    axios({
      method: "GET",
      url: `${localStorage.getItem("apiUrl")}/kprint/`,
      params: {
        pkValue: selectedRow.getData()["primaryKey"],
        invoice: tableConfig.hasInvoice,
        options: {0: tableConfig.options[0].value},
        date: {},
      },
      headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
    }).then((response) => {
      response.data.type = "billPrintFromTable";
      setprint(response.data);
      navigate("/factorprint");
    });
  }

  function editHandler(SelectedRow) {
    axios({
      method: "GET",
      url: `${localStorage.getItem("apiUrl")}/get-form/`,
      params: {
        pkValue: selectedRow.getData()["primaryKey"],
        id: id,
        state: "edit",
      },

      headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
    }).then((response) => {
      setprint(response.data);

      navigate("/Operation/1-m");
    });
  }

  function editHandler2() {
    axios({
      method: "GET",
      url: `${localStorage.getItem("apiUrl")}/get-form/`,
      params: {
        pkValue: selectedRow.getData()["primaryKey"],
        id: id,
        state: "edit",
      },

      headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
    }).then((response) => {
      setprint(response.data);

      navigate("/Operation/2-m");
    });
  }

  function removeRow(row) {
    const removeRequest = axios({
      method: "DELETE",
      url: `${localStorage.getItem("apiUrl")}/frm_submit/`,
      params: {
        pkValue: row.getData()["primaryKey"],
        entityName: tableConfig.entityName,
      },
      headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
    })
      .then((response) => {
        debugger;
        row.delete();
        setSelectedRow();
      })
      .catch((error) => {
        debugger;
        console.log(error);
      });
    toast.promise(removeRequest, {
      pending: "در حال حذف رکورد از سرور",
      success: "رکورد با موفقیت حذف شد",
      error: "حذف رکورد موفقیت آمیز نبود",
    });
  }

  const SendTabulatorFilteredData = () => {
    const tbData = myReactTabulatorRef.current.table;
    console.log(tbData)
    debugger
    tbData.selectRow("visible");
    const tbSelected = tbData.getSelectedData();
    const requestArray = []
    const countArray = []

    tbData.getSelectedData().map(v => requestArray.push(v.primaryKey))
    tbData.getSelectedData().map(v => countArray.push(parseInt(v.na_326)))
    requestArray.shift();
    countArray.shift();
    //    بریم که درخواست بزنیم بک
    const CodesArrayFormData = new FormData();
    CodesArrayFormData.append('id', `[${requestArray}]`);
    CodesArrayFormData.append('type', 'id');
    axios({
      method: 'post',
      url: `${localStorage.getItem("apiUrl")}/barcode/`,
      // params: {id: temp, type: typeToSendBack},
      data: CodesArrayFormData,
      headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
    })
      .then((response) => {
        console.log(response.data);
        if (response.data.length > 0) {
          response.data.map((v, i) => {
            v.barcodeCount= countArray[i]
          });


          response.data.type = "barcodePrintFromBuyBill";
          const sendData = {type:response.data.type , data:response.data  }
          setprint(sendData);
          navigate("/factorprint");
        }
      }).catch(error => {
      debugger
      console.log(error)
    });

  }
  if (tableConfig !== undefined) {
    return (
      <div className="table-component">
        <h3>{tableConfig.title}</h3>
        <div>
          {(tableConfig.canInsert ||
            tableConfig.canDelete ||
            tableConfig.hasKpi ||
            tableConfig.hasInvoice ||
            tableConfig.hasMobile ||
            tableConfig.canEdit) && (
            <div className="btn-container d-flex flex-stat mx-1">
              {tableConfig.canInsert && (
                <button
                  className="btn btnFixedOverWrite"
                  onClick={() => setAddDataModalIsOpen(true)}
                >
                  <i className="fa fa-plus"></i> افزودن
                </button>
              )}
              {tableConfig.canDelete && (
                <button
                  className="btn btnFixedOverWrite"
                  onClick={removeRowHandler}
                >
                  <i className="fa fa-trash"></i> حذف
                </button>
              )}
              {(id === "234-s" || id === "279-s") && (
                <button
                  className="print-btn btn btnFixedOverWrite"
                  onClick={printTableHandler}
                >
                  <i className="fas fa-print mr-2"></i>پرینت
                </button>
              )}
              {tableConfig.canEdit && (
                <>
                  {tableConfig.entityName === "FAKLOZBUE" ||
                  tableConfig.entityName === "FAKKOLBUE" ? (
                    <button
                      className="btn btnFixedOverWrite"
                      onClick={editHandler}
                      disabled={selectedRow === undefined}
                    >
                      <i className="fa fa-edit"></i> ویرایش
                    </button>
                  ) : tableConfig.entityName === "FAKJOZSELL" ||
                  tableConfig.entityName === "FAKKOLSELL" ? (
                    <button
                      className="btn btnFixedOverWrite"
                      // onClick={()=>navigate("/Operation/2-m")}
                      onClick={editHandler2}
                      disabled={selectedRow === undefined}
                    >
                      <i className="fa fa-edit"></i> ویرایش
                    </button>
                  ) : (
                    <button
                      className="btn btnFixedOverWrite"
                      onClick={() => setEditRecordModalIsOpen(true)}
                      disabled={selectedRow === undefined}
                    >
                      <i className="fa fa-edit"></i> ویرایش
                    </button>
                  )}
                  <Modal
                    isOpen={editRecordrModalIsOpen}
                    modalCallback={editRecordModalCallbackHandler}
                  >
                    <ModalHeader title={"ویرایش"}/>
                    <ModalBody>
                      <Form
                        id={id}
                        primaryKey={
                          selectedRow === undefined
                            ? undefined
                            : selectedRow.getData()["primaryKey"]
                        }
                      />
                    </ModalBody>
                  </Modal>
                </>
              )}


              {tableConfig.hasMobile && (
                <>
                  {
                    <button
                      className="btn btnFixedOverWrite"
                      onClick={() => setSmsModalIsOpen(true)}
                    >
                      <i className="fa fa-edit"></i> پیامک
                    </button>
                  }

                  <Modal
                    isOpen={smsModalIsOpen}
                    modalCallback={smsModalCallbackHandler}
                  >
                    <ModalHeader title={"متن پیامک"}/>
                    <ModalBody>
                      <>
                        <p>لطفا متن پیامک را وارد کنید</p>
                        <textarea
                          className="sms-textarea  my-3"
                          ref={smsTextRef}
                        ></textarea>
                        <button
                          className="btn btnFixedOverWrite"
                          onClick={submitSmsHandler}
                        >
                          ارسال
                        </button>
                      </>
                    </ModalBody>
                  </Modal>
                </>
              )}
              {/* در هر صورت این نمایش داده میشه. دکمه پرینت بارکد_ بعد از  گزینه های افزودن ویرایش و حذف میاد*/}
              {
                <button
                  className="btn btnFixedOverWrite"
                  onClick={SendTabulatorFilteredData}>
                  <i className="fa fa-plus"></i> پرینت بارکد
                </button>
              }
              {tableConfig.hasKpi && (
                <>
                  {tableConfig.entityName === "FAKLOZBUE" ||
                  tableConfig.entityName === "FAKKOLBUE" ? (
                    <button
                      className="btn btnFixedOverWrite"
                      onClick={() => {
                        navigateTo("/FormKpiBuilder", {
                          state: {
                            value: {
                              id: id,
                              hasKpiId: tableConfig.hasKpi,
                              kpiOptions: tableConfig.kpiOptions,
                            }
                          }
                        })
                      }}
                      disabled={selectedRow === undefined}
                    >
                      <i className="fa fa-edit"></i> افزودن KPI
                    </button>
                  ) : tableConfig.entityName === "FAKJOZSELL" ||
                  tableConfig.entityName === "FAKKOLSELL" ? (
                    <button
                      className="btn btnFixedOverWrite"
                      onClick={() => {
                        navigateTo("/FormKpiBuilder", {
                          state: {
                            value: {
                              id: id,
                              hasKpiId: tableConfig.hasKpi,
                              kpiOptions: tableConfig.kpiOptions,
                            }
                          }
                        })
                      }}
                    >
                      <i className="fa fa-edit"></i> افزودن KPI
                    </button>
                  ) : (
                    <button
                      className="btn btnFixedOverWrite"
                      onClick={() => {
                        navigateTo("/FormKpiBuilder", {
                          state: {
                            value: {
                              id: id,
                              hasKpiId: tableConfig.hasKpi,
                              kpiOptions: tableConfig.kpiOptions,
                            }
                          }
                        })
                      }}
                    >
                      <i className="fa fa-edit"></i> افزودن KPI
                    </button>
                  )}
                </>
              )}
              {tableConfig.hasKpi && (
                <>
                  {tableConfig.allKpi.kpi && (
                    <>
                      {tableConfig.allKpi.kpi.map((value, index) => (
                        <button
                          className="btn btnFixedOverWrite"
                          onClick={() => {
                            navigateTo("/openKpiPage", {
                              state: {value: value},
                            });
                          }}
                        >
                          {value.title}
                        </button>
                      ))}
                    </>
                  )}
                </>
              )}
              {/* mrm15 */}
              {/*اینجا پرینت هست من فعلا اینو کامنت کردم*/}
              <div>
                {/*<ReactToPrint content={() => myReactTabulatorRef.current} >*/}
                {/*    <PrintContextConsumer>*/}
                {/*        {({handlePrint}) => (*/}
                {/*            <button*/}
                {/*                className="btn btnFixedOverWrite btn-info"*/}
                {/*                onClick={handlePrint}>پرینت جدول</button>*/}
                {/*        )}*/}
                {/*    </PrintContextConsumer>*/}
                {/*</ReactToPrint>*/}
              </div>
              {tableConfig.hasInvoice && (
                <>
                  {tableConfig.options.length === 1 &&
                  tableConfig.hasDate === false ? (
                    <button
                      className="btn btnFixedOverWrite"
                      onClick={printFactorHandler}
                      disabled={selectedRow === undefined}
                    >
                      <i className="far fa-file-alt"></i>
                      {tableConfig.title2}
                    </button>
                  ) : (
                    <button
                      className="btn btnFixedOverWrite"
                      onClick={() => setinvoiceModalIsOpen(true)}
                      // onClick={printFactorHandler}
                      // disabled={selectedRow === undefined}
                    >
                      <i className="far fa-file-alt"></i>
                      {tableConfig.title2}
                    </button>
                  )}
                  <Modal
                    isOpen={invoiceModalIsOpen}
                    modalCallback={invoiceModalIsOpenCallbackHandler}
                  >
                    <ModalHeader title={tableConfig.title2}/>
                    <ModalBody>
                      <FormBill
                        id={id}
                        invoiceId={tableConfig.hasInvoice}
                        primaryKey={
                          selectedRow === undefined
                            ? undefined
                            : selectedRow.getData()["primaryKey"]
                        }
                        data={tableConfig.options}
                        hasDate={tableConfig.hasDate}
                      />
                    </ModalBody>
                  </Modal>
                </>
              )}
              {/* / End This Section mrm15*/}
              {/* TO DO */}
              {/* <button className="btn btnFixedOverWrite">
              <i className="fa fa-print"></i> پرینت
            </button> */}
            </div>
          )}
          {/*<ComponentToPrintReactTabulator*/}
          {/*    ref={myReactTabulatorRef}*/}
          {/*    dataIn={tableConfig.data}*/}
          {/*    columnsIn={tableConfig.columns}*/}
          {/*    optionsIn={tableOptions}*/}
          {/*    eventsIn={{rowClick: rowClickHandler}}*/}
          {/*/>*/}
          <ReactTabulator
            // NOTE: Don't add bootstrap "table" class
            // className="table"
            ref={myReactTabulatorRef}
            data={tableConfig.data}
            columns={tableConfig.columns}
            options={TabulatorTableOptions.style1}
            events={{rowClick: rowClickHandler}}
          />
        </div>
        <Modal
          isOpen={addDataModalIsOpen}
          modalCallback={addDataModalCallbackHandler}
        >
          <ModalHeader title={"افزودن"}/>
          <ModalBody>
            <Form id={id}/>
          </ModalBody>
        </Modal>
      </div>
    );
  } else {
    return (
      <>
        <div></div>
        <Loader/>
      </>
    );
  }
}
